<script>
import AuthContainer from "@/components/auth/AuthContainer";
import { MIN_PW_LENGTH } from "@/helpers/validations";
import RegistrationInput from "@/components/registration/RegistrationInput";
import { onRouteFailing } from "@/helpers/router";
import { resetPassword } from "@/helpers/auth";

export const CONFIRM_PW_ERROR = "Passwords must match";
export const REDIRECT_DESTINATION = { name: "home" };

export default {
  name: "ViewsAuthRegistration",
  components: {
    AuthContainer,
    RegistrationInput,
  },

  data() {
    return {
      confirmPassword: "",
      confirmPasswordError: "",
      formError: null,
      password: "",
      passwordError: "",
      isLoading: false,
    };
  },

  computed: {
    isDisabled() {
      return (
        this.confirmPassword.length < MIN_PW_LENGTH ||
        this.password.length < MIN_PW_LENGTH ||
        this.password !== this.confirmPassword ||
        this.isLoading
      );
    },
  },

  methods: {
    async handleSubmit() {
      this.formError = null;
      this.isLoading = true;

      try {
        await resetPassword(
          this.$route.query.email,
          this.password,
          this.$route.query.resetPasswordToken,
        );

        this.$router.push(REDIRECT_DESTINATION).catch(onRouteFailing);
      } catch (ex) {
        this.formError = this.$t("Unable to set password successfully.");
      }
    },

    setConfirmPasswordError() {
      this.confirmPasswordError =
        this.password &&
        this.confirmPassword &&
        this.password !== this.confirmPassword
          ? this.$t(CONFIRM_PW_ERROR)
          : "";
    },

    validateConfirmPassword(confirmPassword) {
      this.confirmPassword = confirmPassword;

      this.setConfirmPasswordError();
    },

    validatePassword(password) {
      this.password = password;

      this.setConfirmPasswordError();
    },
  },
};
</script>

<template>
  <AuthContainer :title="$t('Set Password')" :error="formError">
    <form @submit.prevent="handleSubmit">
      <RegistrationInput
        :label="$t('Password')"
        name="password"
        :error-override="passwordError"
        @validate="validatePassword"
      />
      <RegistrationInput
        :label="$t('Confirm Password')"
        name="confirmPassword"
        :error-override="confirmPasswordError"
        @validate="validateConfirmPassword"
      />
      <button class="set-password__submit" type="submit" :disabled="isDisabled">
        {{ $t("Set Password") }}
      </button>
    </form>
  </AuthContainer>
</template>

<style lang="scss" scoped>
button {
  inline-size: 100%;
  text-align: center;
}

form {
  margin-block-start: 1.4rem;

  .confetti-input {
    margin-block-end: 1.4rem;

    &:nth-of-type(2) {
      margin-block-end: 2.8rem;
    }
  }
}
</style>
